import React,  {Component} from 'react'; 
import { connect } from 'react-redux'
import { compose } from 'redux'
import Translation from '../General/Translation'
import TrailerVideo from './TrailerVideo'
import toJS from '../hoc/toJS';
import { setYoutubeCookieConfirmation } from '../actions';
import getData from '../functions/getData';
import { UI_TRAILER } from '../constants/state';
import hasIsMobile from '../hoc/hasIsMobile';

const mapDispatchToProps = (dispatch, ownProps) => ({
    setYoutubeCookieConfirmation: (bool) => {
        dispatch(setYoutubeCookieConfirmation(bool))
    }
})

const mapStateToProps = (state, ownProps) => ({
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation'])
})

class TrailerVideoWrapper extends Component {
    constructor (props) {
        super(props) 
        this.state = {
            needFskConfirmation: false,
            allowYoutubeOnce: false,
            allowYoutubeEverytime: true,
            isYoutube: true
        }
        
        this.closeConfirmation = this.closeConfirmation.bind(this)
        this.setAllowance = this.setAllowance.bind(this)
        this.setCookieConfirmation = this.setCookieConfirmation.bind(this)
    }

    componentDidMount() {
        const {fsk} = this.props

        if(parseInt(fsk) === 16 ||parseInt(fsk) === 18) {
            this.setState({
                needFskConfirmation: true
            })
        }
    }

    closeConfirmation(bool) {
        this.setState({
            needFskConfirmation: bool
        })
    }

    setAllowance(bool) {
        this.setState({
            allowYoutubeEverytime: bool
        })
    }

    setCookieConfirmation() {
        const { setYoutubeCookieConfirmation } = this.props 
        const { allowYoutubeEverytime } = this.state

        if(allowYoutubeEverytime && window.BorlabsCookie) {
            if(window.borlabsCookieConfig.pluginVersion || window.borlabsCookieConfig.settings.pluginVersion) {
                window.BorlabsCookie.Consents.addConsent('youtube', 'external-media')
            } else {
                window.BorlabsCookie.addConsent("external-media", "youtube");
            }

            setYoutubeCookieConfirmation(true)
        }

        this.setState({
            allowYoutubeOnce: true
        })
    }

    render () {
        const {trailerURL, fsk, disableTrailer, prerollUrl, hasYoutubeCookieConfirmation, translation, isMobile} = this.props
        const {needFskConfirmation, allowYoutubeOnce, allowYoutubeEverytime, isYoutube} = this.state
        const boxCheckedClass = allowYoutubeEverytime ? ' checked' : ''
        const needCookieConfirmation = hasYoutubeCookieConfirmation ? false : !allowYoutubeOnce

        return (
            <div className={"trailer-wrapper" + (!needCookieConfirmation && !needFskConfirmation ? ' has-video' : '')}>
                {needCookieConfirmation ? (
                    <div className="trailer-content">
                        <div className="trailer-confirmation trailer-confirmation-cookie">
                            <p className="trailer-confirmation-text">
                                <span className="text-medium"><Translation id="attention" trans={translation}>ACHTUNG</Translation>!</span>
                                <span className="text-medium"><Translation id="youtubeConsent" trans={translation}>Mit dem Laden des Videos akzeptieren Sie die Datenschutzerklärung von YouTube.</Translation></span>
                            </p>

                            <a href="https://policies.google.com/privacy" target={"_blank"} className="button text-medium trailer-confirmation-button cancel cursor-pointer">
                                <Translation id="moreButton" trans={translation}>Weiterlesen</Translation>
                            </a>

                            <button onClick={() => this.setCookieConfirmation()} className="button text-medium trailer-confirmation-button confirm cursor-pointer">
                                <Translation id="loadVideo" trans={translation}>Video laden</Translation>
                            </button>
                            
                            {window.BorlabsCookie && <button onClick={() => this.setAllowance(!allowYoutubeEverytime)} className={"text-medium set-allowance cursor-pointer" + boxCheckedClass}>
                                <Translation id="setContent" trans={translation}>Immer entsperren.</Translation>
                            </button>}
                        </div>
                    </div>

                ) : (
                    <div className="trailer-content">
                        {needFskConfirmation && <div className="trailer-confirmation trailer-confirmation-age">
                            <p className="trailer-confirmation-text text-medium">
                                <span><Translation id="attention" trans={translation}>ACHTUNG</Translation>!</span>
                                <span><Translation id="youHaveToAtLeast" trans={translation}>Du musst mindestens</Translation> {fsk} <Translation id="yearsOldToSeeThisTrailer" trans={translation}>Jahre alt sein, um diesen Trailer sehen zu dürfen</Translation>.</span>
                            </p>
                            <button onClick={disableTrailer} className="button text-medium trailer-confirmation-button cancel cursor-pointer has-popup-close">
                                <Translation id="close" trans={translation}>Schließen</Translation>
                            </button>
                            <button onClick={() => this.closeConfirmation(false)} className="button text-medium trailer-confirmation-button confirm cursor-pointer">
                                <Translation id="watchTrailer" trans={translation}>Trailer anschauen</Translation>
                            </button>
                        </div>}

                        {!needFskConfirmation && <TrailerVideo trailerURL={trailerURL} prerollUrl={prerollUrl} isMobile={isMobile}/>}
                    </div>

                )}

            </div>

        )
    }
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(hasIsMobile(TrailerVideoWrapper))